import React from 'react'
import createReactClass from 'create-react-class'
import './translations.css'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table'
import EditTranslationIconPanel from './edit-translation-icon-panel'
import ErrorBlock from '../../elements/error-block'
import {TranslationsFormData} from '../../util/helpers'

export default createReactClass({
  updateTranslations (data, resourceId, index) {
    this.props.updateTranslations(data, resourceId, index)
  },
  rowFormatter (cell, row) {
    return <EditTranslationIconPanel onSave = {this.createPortfolio} translations={row}
      update={this.updateTranslations} index={row.tableIndex} isUpdated={this.props.isTranslationUpdated}
      loader = {this.props.modalLoader} error={this.props.modalError} onModalClose={this.props.resetError}/>
  },
  getWidth (key) {
    if (key === 'resourceId' || key === 'trans') {
      return '350'
    } else if (key === 'edit') {
      return '30'
    } else if (key === 'createdDate' || key === 'modifiedDate') {
      return '150'
    }
    return '120'
  },
  render () {
    const options = {
      sizePerPageList: [ {
        text: '25', value: 25,
      }, {
        text: '50', value: 50,
      }, {
        text: '100', value: 100,
      }],
      sizePerPage: 25,
    }
    return (
      <div className="search-result-panel">
        <div className='translations-panel' >
          {this.props.loader
            ? <div className='loader-ctr'>
              <span className="loading">
              </span>
            </div>
            : <div>
              {this.props.error.message
                ? <ErrorBlock {...this.props.error}/>
                : <div className="cs-search-table">
                  <BootstrapTable data={this.props.translations} striped hover condensed
                    trClassName='bootstrap-table-tr'
                    pagination={true} options={options} keyField='resourceId'>
                    {TranslationsFormData.columns.map((column, index) =>
                      column.key === 'edit'
                        ? <TableHeaderColumn dataField={column.key} dataAlign='left' width={this.getWidth(column.key)}
                          key={index} dataFormat={this.rowFormatter}>
                          {column.name}
                        </TableHeaderColumn>
                        : <TableHeaderColumn dataField={column.key} dataAlign='left' width={this.getWidth(column.key)}
                          key={index}>
                          {column.name}
                        </TableHeaderColumn>)
                    }
                  </BootstrapTable>
                </div>
              }
            </div>
          }
        </div>
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/monitoring-translations/translations-result.js